/* tslint:disable */
require('./FieldNameRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_5742f515',
  relative: 'relative_5742f515',
  signalField: 'signalField_5742f515',
  fabricIcon: 'fabricIcon_5742f515',
  signal: 'signal_5742f515',
  newItem: 'newItem_5742f515',
  newIcon: 'newIcon_5742f515',
  signalFieldValue: 'signalFieldValue_5742f515',
  value: 'value_5742f515',
};

export default styles;
/* tslint:enable */